'use client';

import { SuggestedCategory, SuggestedKeywords } from '~/apis/search';
import { Typography } from '@bgzt/ui';
import { HighlightedKeyword } from '~/app/search/_components';

import styles from './SuggestedKeywordList.module.css';

type Props = {
  q: string;
  suggestedKeywords?: SuggestedKeywords;
  onKeywordClick?(value: string, index: number): void;
  onCategoryClick?(category: SuggestedCategory, index: number): void;
};
export const SuggestedKeywordList = ({ q, suggestedKeywords, onKeywordClick, onCategoryClick }: Props) => {
  if (!suggestedKeywords) return null;

  const { categories, keywords } = suggestedKeywords;

  const convertedHighlightKeywords = convertHighlightKeywords(q, keywords);

  return (
    <>
      {!!categories?.length && (
        <ul>
          {categories.map((category, index) => (
            <li key={category.categoryId} className={styles.item} onClick={() => onCategoryClick?.(category, index)}>
              <Typography variant="L4" color="gray-900">
                {category.keyword}{' '}
              </Typography>
              <Typography variant="L4" color="gray-300">
                {category.desc}
              </Typography>
              <Typography variant="L14" color="gray-300">
                {' · 카테고리'}
              </Typography>
            </li>
          ))}
        </ul>
      )}

      {!!convertedHighlightKeywords?.length && (
        <ul className={styles.keywords}>
          {convertedHighlightKeywords?.map(({ keyword, highlightedElement }, index) => (
            <li key={keyword} className={styles.item} onClick={() => onKeywordClick?.(keyword, index)}>
              <Typography variant="L4">
                <HighlightedKeyword content={highlightedElement} />
              </Typography>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

const convertHighlightKeywords = (q: string, keywords: SuggestedKeywords['keywords']) =>
  keywords?.map((keyword) => {
    const escapeRegExp = (value: string) => {
      return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    const escapedSearchValue = escapeRegExp(q);

    const splitedValue = escapedSearchValue?.split(' ').filter((el) => el !== '');

    const reg = new RegExp(`${splitedValue.join('|')}`, 'gi');
    const highlightedElement = keyword?.replace(reg, (el) => {
      return `<span>${el}</span>`;
    });

    return {
      keyword,
      highlightedElement,
    };
  });
